import React, { Fragment, useEffect, useState } from "react";
import { DesktopButtons, MobileButtons, ResponsiveHeader } from "pages/_components/header";
import { useSelector, useDispatch } from "react-redux";
import { bool } from "prop-types";
import { useParams, Link } from "react-router-dom";
import MainContainer from "pages/_components/MainContainer";
import { actions as discountsActions, actions as DiscountsActions } from "reducers/discounts";
import { actions as echeckActions } from "reducers/echecks";
import Loader from "pages/_components/Loader";
import Button from "pages/_components/Button";
import Notification from "pages/_components/Notification";
import CustomText from "pages/_components/CustomText/CustomText";
import GridTable from "pages/_components/GridTable/GridTable";
import ProductList from "pages/_components/product/List";
import Action from "pages/_components/Action";
import { push } from "connected-react-router";

import { getStatusTagColor } from "util/discounts";
import InfoTag from "pages/discounts/_components/InfoTag";
import gaEventTracker, { events } from "util/gaEventTracker";
import { isIOS } from "react-device-detect";
import TitleColumns from "./_components/TitleColumns";
import VendorDiscountsItem from "./_components/ItemRow";
import DataDetailDiscounts from "./_components/DataDetailDiscounts";

const DetailDiscounts = ({ isDesktop }) => {
    const { echeqDetail, fetching: fetchingDetail } = useSelector((state) => state.echecks);
    const { transaction } = useSelector((state) => state.discounts);
    const { fetching, fetchingDownload, echeqDocuments, transactionsEcheqDiscount } = useSelector(
        (state) => state.discounts,
    );
    const { id } = useParams();

    const dispatch = useDispatch();

    const dataLot = transactionsEcheqDiscount?.find((item) => item.idTransaction === id);
    const hasParcials = dataLot?.allowNegotiatePartial;

    const [searchDetails, setSearchDetails] = useState(true);
    const [hasAcceptedEcheq, setHasAcceptedEcheq] = useState(false);

    const [idxEcheq, setIdxEcheq] = useState(0);

    /* const fileId = transaction?.file[0]?.fileId; */
    useEffect(() => {
        const data = {
            dateFrom: null,
            dateTo: null,
            pageNumber: 1,
            status: "",
            idBatch: "",
        };
        dispatch(DiscountsActions.setDiscountFilters({ ...data }));
        dispatch(DiscountsActions.loadListDiscountRequest());
        dispatch(discountsActions.getTransaction(id, true));
        dispatch(
            discountsActions.loadListEcheqLotRequest({
                id,
                pageNumber: 1,
                status: "TODOS",
                /* fileId, */
            }),
        );
    }, []);

    useEffect(() => {
        if (
            echeqDocuments &&
            echeqDocuments.length > 0 &&
            searchDetails &&
            !fetchingDetail &&
            idxEcheq < echeqDocuments.length
        ) {
            dispatch(echeckActions.requestEcheqDetail(echeqDocuments[idxEcheq].echeqId));
            const i = idxEcheq + 1;
            setIdxEcheq(i);
        } else if (echeqDocuments.length > 0 && idxEcheq >= echeqDocuments.length) {
            setSearchDetails(false);
        }
    }, [echeqDocuments, fetchingDetail]);

    useEffect(() => {
        if (echeqDetail) {
            if (
                echeqDetail.endosos &&
                echeqDetail.endosos > 0 &&
                echeqDetail.endosos.findIndex((e) => e?.estado_endoso === "aceptado") !== -1
            ) {
                setSearchDetails(false);
                setHasAcceptedEcheq(true);
            }
        }
    }, [echeqDetail]);

    if (fetching) {
        return <Loader />;
    }

    /* const handleClickDonload = () => {
        dispatch(discountsActions.downloadDocument(fileId));
    }; */

    const handleDownload = () => {
        gaEventTracker.triggerEvent(events.echeq_descargar());

        dispatch(
            discountsActions.downloadFileEcheqBatch({
                dataLot,
                echeqDocumentsQuantity: echeqDocuments.length ?? 0,
                echeqDocuments,
            }),
        );
    };

    const State = () => (
        <InfoTag
            tagClass="discounts-echeq-tag__status ml-5"
            type="info"
            message={dataLot?.statusLabel}
            tagBackground={getStatusTagColor(dataLot?.status)}
        />
    );

    const negotiateApproved = () => {
        const approvedEcheqs = echeqDocuments.filter((e) => e.status === "APPROVED");
        dispatch(
            discountsActions.setApprovedEcheqs(
                approvedEcheqs.map((e) => e?.echeqId),
                transaction?.idActivity === "openLot.ownEcheq.send" ? "ownEcheqType" : "thirdPartyEcheqType",
            ),
        );
        dispatch(push(`/discounts`));
    };

    return (
        <Fragment>
            <Notification scopeToShow="detailDiscounts" />

            <ResponsiveHeader infoComponents={<State />} id="detail.discounts.title">
                <DesktopButtons>
                    <Button
                        onClick={() => handleDownload()}
                        className="btn btn-outline"
                        bsStyle="link"
                        image="images/figma/icon/download.svg"
                        label="global.download"
                        loading={fetchingDownload || fetching}
                    />
                </DesktopButtons>

                <MobileButtons
                    image={isIOS ? "images/figma/icon/menu-ios-white.svg" : "images/figma/icon/menu-ios.svg"}>
                    <Action labelKey="global.download" handleClick={() => handleDownload()} />
                </MobileButtons>
            </ResponsiveHeader>

            <MainContainer showLoader={fetching || searchDetails}>
                {!!dataLot?.idBatch && (
                    <GridTable>
                        <GridTable.Container columns={2} rows={1}>
                            <GridTable.Data columnStart={1} alignX="start" rowStart={1}>
                                <div className="detail-discount-breadcrumb">
                                    <CustomText text={`ID de Lote: `} />
                                    <CustomText className="f-weight-b" text={dataLot?.idBatch} />
                                    {/* <Button className="btn btn-link btn-block" onClick={handleClickDownload}>
                                    {`Archivo: ${transaction?.file[0]?.fileName}`}
                                </Button> */}
                                </div>
                            </GridTable.Data>
                            {!isDesktop && (
                                <GridTable.Data columnStart={2} alignX="end" rowStart={1}>
                                    <State />
                                </GridTable.Data>
                            )}
                        </GridTable.Container>
                    </GridTable>
                )}

                <DataDetailDiscounts isDesktop={isDesktop} />

                <ProductList
                    fetchingWithPreviousData
                    fetching={fetching}
                    items={echeqDocuments || []}
                    noDataText="global.no.results"
                    noFiltersDataText="debin.global.no.results"
                    renderItem={(item) => (
                        <GridTable.Container
                            key={`providers-Discounts-item-${item.echeqNumber}`}
                            renderAs={Link}
                            className={!isDesktop && "box box-shadow"}
                            to={`/Discounts/providers/detail/echeq/${id}/${item.echeqNumber}`}>
                            <VendorDiscountsItem
                                key={`transaction-${id}`}
                                recibedDiscounts={item}
                                isDesktop={isDesktop}
                                showStatus={hasParcials}
                            />
                        </GridTable.Container>
                    )}>
                    {(listItem) => (
                        <GridTable
                            className={`detail-discounts-table tablelist ${hasParcials && "with-partials"} pb-7`}>
                            <GridTable.Header>
                                <GridTable.Container rows={1}>
                                    <TitleColumns showStatus={hasParcials} />
                                </GridTable.Container>
                            </GridTable.Header>
                            <GridTable.Body>{listItem}</GridTable.Body>
                        </GridTable>
                    )}
                </ProductList>
                {!!hasParcials && !hasAcceptedEcheq && (
                    <div className="grid-table form-actions">
                        <div className="grid-table-row sm:flex md:grid-cols-12">
                            <div className="grid-table-data md:col-start-5 md:col-span-4">
                                <Button
                                    bsStyle="primary"
                                    defaultLabelText="Negociar aprobados"
                                    loading={false}
                                    block
                                    onClick={negotiateApproved}
                                    disabled={false}
                                />
                            </div>
                        </div>
                    </div>
                )}
            </MainContainer>
        </Fragment>
    );
};
DetailDiscounts.propTypes = {
    isDesktop: bool.isRequired,
};

export default DetailDiscounts;
